import { useMemo } from 'react';
import { Box } from '@/UI/Box/Box';
import { LabelSmRg, TextSmRg } from '@/UI/AppTypography/AppTypography';
import { FlexCol } from '@/UI/styles';
import GalleryParams from '@/components/Recipe/FlowComponents/Gallery/GalleryParams';
import type { UploadedAsset } from '@/types/api/assets';

interface GalleryInfoContainerProps {
  selectedFile: UploadedAsset;
  zoomPercentage?: number;
}

export const GalleryInfoContainer = ({ selectedFile, zoomPercentage }: GalleryInfoContainerProps) => {
  const paramsInputs = useMemo(() => {
    if (selectedFile && (selectedFile.type === 'image' || selectedFile.type === 'video')) {
      return { ...(selectedFile.params || {}), ...(selectedFile.input || {}) };
    }
    return {};
  }, [selectedFile]);
  if (selectedFile?.type !== 'image' && selectedFile?.type !== 'video') {
    return null;
  }
  return (
    <FlexCol
      data-testid="file-info-container"
      sx={{
        position: 'absolute',
        top: 10,
        left: 20,
      }}
    >
      {selectedFile.name && (
        <TextSmRg
          sx={{
            fontWeight: 'bold',
            fontSize: '10px',
            textShadow: '0px 0px 2px black',
          }}
        >
          {`${selectedFile.name}`}
        </TextSmRg>
      )}
      <LabelSmRg>
        {selectedFile.width}x{selectedFile.height}
        {selectedFile.duration ? ` | ${selectedFile.duration.toFixed(2)}s` : ''}
        {selectedFile.fps ? ` | ${selectedFile.fps.toFixed(2)} fps` : ''}
        {selectedFile.type === 'image' ? ` | ${zoomPercentage}%` : ``}
      </LabelSmRg>
      {(selectedFile.params || selectedFile.input) && (
        <Box sx={{ position: 'relative' }}>
          <GalleryParams inputs={paramsInputs} />
        </Box>
      )}
    </FlexCol>
  );
};
